import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: "",
    message: "",
}


export const shopifyConnection = createAsyncThunk("shopifyConnection", async (bcData) => {
    try {
        const response = await fetch(`/api/shopifyConnection`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bcData)
        })
        if (!response.ok) {
            throw new Error('Shopify connection failed');
        }
        return await response.text();
    } catch (error) {
        throw new Error('Shopify connection failed', error);
    }
});

const connectionSlice = createSlice({
    name: "getConnectionStatus",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(shopifyConnection.pending, (state) => {
            state.status = "BC loading"
            state.message = "Please wait"
        });
        builder.addCase(shopifyConnection.fulfilled, (state, action) => {
            if (action.payload == '{"status":"SUCCESS"}') {
                state.status = "success"
                state.message = "Shopify connection success"
            }else{
                state.status = "error"
                state.message = "Shopify connection failed"
            }    
        });
        builder.addCase(shopifyConnection.rejected, (state) => {
            state.status = "error"
            state.message = "Shopify connection failed"
        });
    }
})

export default connectionSlice.reducer